module.exports = __webpack_public_path__ + "img/Menu-13.5e4d0d4c.png";